window.variantChanged = false;
window.currentVariant = "subscription";
window.selectedVariantsArray = [];
window.translationsText = window.translationsText || {};
window.translationsText.stickyFilled = 'View color selection';
window.translationsText.farbe = 'Color';
window.translationsText.design = "Design";
window.translationsText.buttonUnfilled = 'Choose Design';
window.translationsText.optionale = 'Optional Design';

if ($('body').hasClass('set_refil_new_dip') || $('body').hasClass('set_starter_new_dip')) {
    window.translationsText.design = window.translationsText.farbe;
   window.translationsText.buttonUnfilled = 'Choose Color';
     window.translationsText.optionale = 'Optionals Color';
} 
else if ($('body').hasClass('all_in_one_special_set')) {
    window.translationsText.design = 'Product';
   window.translationsText.buttonUnfilled = 'Choose Product';
     window.translationsText.optionale = 'Optionals Product';
}


$(document).ready(function() {

 $('body').on('click', '.manikure_filter', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active_filter')) {
      $('.manikure_pedikure_filter span').removeClass('active_filter');
      $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
        $(this).show();
      })
    } else {
      $('.manikure_pedikure_filter span').removeClass('active_filter')
      $(this).addClass("active_filter");
      $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
        if ($(this).hasClass('pfilter_pedikure')) {
          $(this).hide();
        } else {
          $(this).show();
        }
      })
      const filterVal = $(this).attr('data-filter-value');
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('doonails:drawer_filter_clicked', {
          filter_value: filterVal,
          product_handle: window.location.pathname.split('/products/')[1] || null
        });
      }
      if (gtag) {
        gtag('event', 'drawer_filter_clicked', {
          'filter_value': filterVal,
          'product_handle': window.location.pathname.split('/products/')[1] || null
        });
      }
    }
  })
  
  
  $('body').on('click', '.pedikure_filter', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active_filter')) {
      $('.manikure_pedikure_filter span').removeClass('active_filter');
      $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
        $(this).show();
      })
    } else {
      $('.manikure_pedikure_filter span').removeClass('active_filter')
      $(this).addClass("active_filter");
      $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
        if (!$(this).hasClass('pfilter_pedikure')) {
          $(this).hide();
        } else {
          $(this).show();
        }
      })
      const filterVal = $(this).attr('data-filter-value');
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('doonails:drawer_filter_clicked', {
          filter_value: filterVal,
          product_handle: window.location.pathname.split('/products/')[1] || null
        });
      }
      if (gtag) {
        gtag('event', 'drawer_filter_clicked', {
          'filter_value': filterVal,
          'product_handle': window.location.pathname.split('/products/')[1] || null
        });
      }
    }
  })



  $(document).on('click', '.color_selecor_drawer', function() {
      $('html, body').animate({
        scrollTop: $('#pick-color-id').offset().top - 100
      }, 100);
      $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
  });
  
    // var $span = $('<span class="Premium_text_top">Most popular!</span>');
    // var $target = $('.block-swatch.custom-po-set:nth-child(2)');
    // $target.prepend($span);

      $('.block-swatch.custom-po-set').each(function () {
        let text = $(this).find('.block-swatch__item').text();
        if (text.includes('Premium') || text.includes('premium')) {
          $(this).prepend($('<span class="Premium_text_top">Most popular!</span>'));
        }
     })

    $('.whats-in-set[aria-controls="whats-in-set"]').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).attr("aria-expanded", "true");
        $('html').addClass('lock-all');
        $('whats-in-set#whats-in-set').attr('open', '')
    })

    $("whats-in-set#whats-in-set .popup-close").on('click', function(event) {
        $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false");
        $('whats-in-set#whats-in-set').removeAttr('open');
        $('html').removeClass('lock-all');
    });

    $('body').on('click', 'color-switcher.color-selection__image', function(e) {
        e.preventDefault();
            
            if ($(this).hasClass('coladded')) {
                // $(this).closest('.color-selection__grid-item').addClass('active');
                // $(this).attr("aria-expanded", "true");
            } else {
              
                $('color-switcher.color-selection__image').each(function() {
                    $(this).attr("aria-expanded", "false");
                    $(this).closest('.color-selection__grid-item').removeClass('active');
                })
              
                $('color-switcher.color-selection__image.readytoselect').closest('.color-selection__grid-item').addClass('active');
                $('color-switcher.color-selection__image.readytoselect').attr("aria-expanded", "true");
    
                $('html').addClass('lock-all');
                $('color-choose-drawer#color-choose-drawer').attr('open', '');
              
            }

    });

const currentUrl = window.location.href;
const decodedUrl = decodeURIComponent(currentUrl);
const urlParams = new URLSearchParams(decodedUrl.split('?')[1]);
const freeVariants = urlParams.get('free_ids')?.split(',') || [];
const discountedVariants = urlParams.get('optional_ids')?.split(',') || [];
const filteredFreeVariants = freeVariants.filter(Boolean);
const filteredDiscountedVariants = discountedVariants.filter(Boolean);
const setId = urlParams.get('set_id');
  
let urlParts = currentUrl.split('&optional_ids');
if (filteredFreeVariants && filteredFreeVariants.length > 0) {
   urlParts = currentUrl.split('&free_ids');
} 
const newUrl = urlParts[0];
//  console.log('newUrl', newUrl) 
window.history.replaceState(null, '', newUrl);

  
function processVariants(variants, selector, delay) {
  return new Promise((resolve) => {
    let completedIterations = 0;

    $.each(variants, function (index, value) {
      setTimeout(() => {
        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $(`${selector}:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        } else {
          $(`${selector}[aria-expanded="false"]:not(.coladded)`)
          .first()
          .attr("aria-expanded", "true");
        }

        $(`color-choose-drawer#color-choose-drawer .product-tile-item[data-variant='${value}']`)
          .trigger("click");

        // Increment the counter and check if all iterations are complete
        completedIterations++;
        if (completedIterations === variants.length) {
          resolve(); // Resolve the promise once all iterations are done
        }
      }, delay);
    });
  });
}


if (filteredFreeVariants && filteredFreeVariants.length > 0) {
  processVariants(filteredFreeVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
      return processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image.optional-switcher', 200);
    } else {
      return true;
    }
  })
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
} else if (filteredDiscountedVariants && filteredDiscountedVariants.length > 0) {
  processVariants(filteredDiscountedVariants, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('set-id', setId);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateProduct');
  });
}



document.addEventListener('variant:changed', function(event) {  
  let eventVariant = event.detail.variant;
  window.variantChanged = false;
  let isColorArray = false;
  let isVariantsArray = false;
  let pre_color_array;
  let preSetId;

  if ($('.color_selected_main .selected_item.coladded').length > 0) {
     $('.color_selected_main .selected_item.coladded').css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
     $('.color_selected_main .selected_item.coladded').removeClass('coladded');
     $('.color_selected_main .selected_item.coladded').removeAttr('variant-id');
  }

  // If we're in the "single products" flow, grab the existing color-array
  if ($('.inventory-product').hasClass('updateSingleProducts')) {
    pre_color_array = $('.inventory-product').attr('color-array');
    isColorArray = true;
  }

  // Collect all selected variant IDs

  let totalColors = parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-free-colors'));
  if ($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors')) {
    totalColors = totalColors + parseInt($(`variant-metacolor input[value="${eventVariant.id}"]`).attr('data-optional-colors'));
  }
  
  let selectedVariantsArrayNew = [];

  if (!window.selectedVariantsArray.length) {
    $('color-switcher.color-selection__image.coladded').each(function (index) {
      if (totalColors > index) {
        selectedVariantsArrayNew.push($(this).attr('variant-id'));      
      }    
    });
  } else {
    selectedVariantsArrayNew = window.selectedVariantsArray.slice(0, totalColors);
    window.selectedVariantsArray.length = 0;
  }

  // If we're in the "set" flow, grab the existing set-id
  if ($('.inventory-product').hasClass('updateProduct')) {
    preSetId = $('.inventory-product').attr('set-id');
    isVariantsArray = true;
  }

  console.log('selectedVariantsArray', selectedVariantsArrayNew);
  

  processVariants(selectedVariantsArrayNew, '#pick-color-id color-switcher.color-selection__image', 200)
    .then(() => {
      if (isVariantsArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('set-id', preSetId)
          .addClass('updateProduct');
      }
      return true;
    })
    .then(() => {
      if (isColorArray) {
        $('form button.inventory-product[data-product-add-to-cart-button]')
          .attr('color-array', pre_color_array)
          .addClass('updateSingleProducts');
      }
      return true;
    })
    .then(() => {
      window.variantChanged = true;
      return true;
    });
});

const singleVariants = urlParams.get('single_colors')?.split(',') || [];
const filteredSingleVariants = singleVariants.filter(Boolean);  
const urlSingleParts = decodedUrl.split('&single_colors');
const newSingleUrl = urlSingleParts[0];
window.history.replaceState(null, '', newSingleUrl);

let singleVariantsArray = [];
let singleVariantsString = '';
filteredSingleVariants.forEach((item) => {
  let itemParts = item.split(':');
  if (singleVariantsString != '') {
    singleVariantsString = singleVariantsString + ',' + item;
  } else {
    singleVariantsString = item;
  }
  singleVariantsArray.push(itemParts[0]);
});

if (singleVariantsArray.length > 0) {
  processVariants(singleVariantsArray, '#pick-color-id color-switcher.color-selection__image', 200)
  .then(() => {
    $('form button.inventory-product[data-product-add-to-cart-button]').attr('color-array', singleVariantsString);
    $('form button.inventory-product[data-product-add-to-cart-button]').addClass('updateSingleProducts');
    return true;
  });
}


  
    $("body").on("click", "color-choose-drawer#color-choose-drawer .product-tile-item", function(e) {
       var target = $(e.target);
       const $this = $(this);

      if (!target.hasClass('dot') 
        && !target.hasClass('flickity-page-dot') 
        && !target.hasClass('quantity_minus') 
        && !target.hasClass('flickity-button') 
        && !target.hasClass('flickity-page-dots') 
        && !target.hasClass('flickity-button-icon')
        && !target.hasClass('color_zoom_popup')
        && !target.hasClass('color_zoom_popup_svg')) {


        const totalsSorted = $('.block-swatch-list .block-swatch input').map(function () {
        const val = $(this).attr('data-total-colors');
          return parseInt(val, 10) || 0;
        }).get().sort((a, b) => a - b);

        let isReturn = false;
        for (let index = 0; index < totalsSorted.length; index++) {
          // console.log('length', $('.color_selected_main .selected_item.coladded').length + 1);
          // console.log('totalsSorted', totalsSorted[index]);
          const valChecked = $('.block-swatch .block-swatch__radio:checked').attr('data-total-colors');
          if (($('.color_selected_main .selected_item.coladded').length + 1) > valChecked) {
            if (($('.color_selected_main .selected_item.coladded').length + 1) > totalsSorted[index] && ($('.color_selected_main .selected_item.coladded').length + 1) <= totalsSorted[index+1]) {
              // totalsSorted.splice(index, 1);
              upgradeVariantAfter($this);
              const varTitle = $(`.block-swatch-list .block-swatch input[data-total-colors="${totalsSorted[index+1]}"]`);
              // console.log('varTitle', varTitle);
              if (varTitle) {
                $(`.block-swatch-list .block-swatch input[data-total-colors="${totalsSorted[index+1]}"]`).siblings('label.block-swatch__item').click();
                isReturn = true;
                break; 
              }
            }
          }
        }

        if (isReturn) {
            return;
        }

      //  let freeColorCount = [];
      //   $('variant-metacolor input').each(function () {
      //     const val = parseInt($(this).attr('data-free-colors'), 10);
      //     if (!isNaN(val)) {
      //       freeColorCount.push(val);
      //     }
      //   });
      //   if (freeColorCount.length > 0) {
      //     freeColorCount.sort(function(a, b) {
      //       return a - b;
      //     });
      //   }

        // for (let index = 0; index < freeColorCount.length; index++) {
        //   if (freeColorCount[index] === $('.color_selected_main .selected_item.coladded').length) {
        //     const nextCount = freeColorCount[index + 1];
        //     const varTitle = $(`variant-metacolor input[data-free-colors="${nextCount}"]`).attr('data-title');
        //     if (varTitle) {
        //       $(`.block-swatch-list .block-swatch input[data-value="${varTitle}"]`) .siblings('label.block-swatch__item').click();
        //       break; 
        //     }
        //   }
        // }

        // if (($('.block-swatch .block-swatch__radio:checked').attr('data-value') == '3 Designs' || $('.block-swatch .block-swatch__radio:checked').attr('data-value') == '3 Colors') && $('.color_selected_main .selected_item.coladded').length == 3) {
        //   upgradeVariantAfter($this);
        //   if ($(`.block-swatch-list .block-swatch input[data-value="4 Designs"]`)) {
        //     $(`.block-swatch-list .block-swatch input[data-value="4 Designs"]`).siblings('label.block-swatch__item').click();
        //   }
        //   if ($(`.block-swatch-list .block-swatch input[data-value="4 Colors"]`)) {
        //     $(`.block-swatch-list .block-swatch input[data-value="4 Colors"]`).siblings('label.block-swatch__item').click();
        //   } 
        //   return;
        // }
        // if (($('.block-swatch .block-swatch__radio:checked').attr('data-value') == '4 Designs' || $('.block-swatch .block-swatch__radio:checked').attr('data-value') == '4 Colors') && $('.color_selected_main .selected_item.coladded').length == 4) {
        //   upgradeVariantAfter($this);
        //   if ($(`.block-swatch-list .block-swatch input[data-value="6 Designs"]`)) {
        //     $(`.block-swatch-list .block-swatch input[data-value="6 Designs"]`).siblings('label.block-swatch__item').click();
        //   }
        //   if ($(`.block-swatch-list .block-swatch input[data-value="6 Colors"]`)) {
        //     $(`.block-swatch-list .block-swatch input[data-value="6 Colors"]`).siblings('label.block-swatch__item').click();
        //   }
        //   return;
        // }

        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $(this).attr("data-file");
        let colorName = $(this).attr("data-name");
        let vendorName = $(this).attr("data-vendor");
        let variantId = $(this).attr("data-variant");
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;
        let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
        let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
        let finalPrice = discountedPrice;
        var count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').removeClass('readytoselect');
        markFarbe.removeClass('readytoselect');
        
        markFarbe.attr('data-price', finalPrice);
        markFarbe.attr('data-percent', discountPercent);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
        markFarbe.attr('data-compare', colorPriceVal);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
      
        if (markFarbe.hasClass('optional-switcher')) {   
          
            let discountPercent = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
            let finalPrice = discountedPrice;
              
            markFarbe.attr('data-price', finalPrice);
            markFarbe.attr('data-percent', discountPercent);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));         

            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
              
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
              
              $('.color-selection__container .color-selection__grid').append(newItemHtml)

            }

        }

        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
          
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorNameSelected} successfully selected`);
        // $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();

        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
    
        } // target.hasClass if end here
    });



  function upgradeVariantAfter($this) {
    const variantPoller = setInterval(() => {
      if (window.variantChanged === true) {
        clearInterval(variantPoller);
       let freeColorCount = [];
        $('variant-metacolor input').each(function () {
          const val = parseInt($(this).attr('data-free-colors'), 10);
          if (!isNaN(val)) {
            freeColorCount.push(val);
          }
        });
        if (freeColorCount.length > 0) {
          freeColorCount.sort(function(a, b) {
            return a - b;
          });
        }
          

        // for (let index = 0; index < freeColorCount.length; index++) {
        //   if (freeColorCount[index] === $('.color_selected_main .selected_item.coladded').length) {
        //     const nextCount = freeColorCount[index + 1];
        //     const varTitle = $(`variant-metacolor input[data-free-colors="${nextCount}"]`).attr('data-title');
        //     if (varTitle) {
        //       $(`.block-swatch-list .block-swatch input[data-value="${varTitle}"]`) .siblings('label.block-swatch__item').click();
        //       break; 
        //     }
        //   }
        // }

        let markFarbe = $('color-switcher.color-selection__image[aria-expanded="true"]');
        let colorImage = $this.attr("data-file");
        let colorName = $this.attr("data-name");
        let vendorName = $this.attr("data-vendor");
        let variantId = $this.attr("data-variant");
        
        let colorPriceVal = parseFloat($this.attr("data-price")) || 0;
        let discountPercent = parseFloat($('#pick-color-id').attr('data-required-off')) || 0;
        let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
        let finalPrice = discountedPrice;
        
        let count = markFarbe.closest('.color-selection__grid-item').attr('data-count');
       
        markFarbe.attr('variant-name', colorName);
        markFarbe.attr('variant-id', variantId);
        markFarbe.attr('variant-img', colorImage);
        markFarbe.attr('data-original-price', colorPriceVal);
          
        markFarbe.css('backgroundImage', `url(${colorImage})`);
        markFarbe.siblings('.farbe-title').text(colorName);
        markFarbe.siblings('.farbe-vendor').text(vendorName);
        markFarbe.addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').addClass('coladded');
        markFarbe.closest('.color-selection__grid-item').removeClass('readytoselect');
        markFarbe.removeClass('readytoselect');

        markFarbe.attr('data-price', finalPrice);
        markFarbe.attr('data-percent', discountPercent);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
        markFarbe.attr('data-compare', colorPriceVal);
        markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
      
        if (markFarbe.hasClass('optional-switcher')) {
            let discountPercent = parseFloat($('#pick-color-id').attr('data-optional-off')) || 0;
            let discountedPrice = colorPriceVal * (1 - discountPercent / 100);
            let finalPrice = discountedPrice;
              
            markFarbe.attr('data-price', finalPrice);
            markFarbe.attr('data-percent', discountPercent);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-price').html(window.globalMoneyFm(finalPrice));
            markFarbe.attr('data-compare', colorPriceVal);
            markFarbe.siblings('.farbe-price_wrapper').find('.farbe-compare').html(window.globalMoneyFm(colorPriceVal));
          
            var countTotal = parseInt(markFarbe.closest('#pick-color-id').attr('data-total-colors'));
            var basicCount = $('#pick-color-id .color-selection__grid-item').length;
            var dataPercent = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-off'));
            var countTotalOptional = parseInt(markFarbe.closest('#pick-color-id').attr('data-optional-colors'));
            let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
          
            let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
          
            if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
              
                let newItemHtml = `<div class="color-selection__grid-item optional-switcher test" data-percent="${dataPercent}" data-count="${basicCount+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                   <span class="discounted_percent">-${dataPercent}%</span>
                   <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${basicCount+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                      <button class="remove_item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                   </color-switcher>
                   <div class="farbe-title">${window.translationsText.optionale}</div>
                   <div class="farbe-vendor"></div>
                   <div class="farbe-price_wrapper">
                      <div class="farbe-price"></div>
                      <div class="farbe-compare"></div>
                   </div>
                </div>`;
              
              $('.color-selection__container .color-selection__grid').append(newItemHtml)

            }

        }

        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
          
        if (!$("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          $('color-choose-drawer#color-choose-drawer').removeAttr('open');
          $('html').removeClass('lock-all');
        }
          
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded').length);

        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
      
        updateCounter();
          
        let colorNameSelected = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
        $('.rosegold_inner').show();
        $('.rosegold_heading p').html(`${colorNameSelected} successfully selected`);
        // $('.design_combinations_inner').hide();
        $('.press_nail_inner').show();

        if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
          updateColorDrawerSlider();
          // $this.addClass('active');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
          // $('.color_selected_main .selected_item:not(.coladded)').first().css('backgroundImage', `url(${colorImage})`);
          // $('.color_selected_main .selected_item:not(.coladded)').first().attr('variant-id', variantId);
          // $('.color_selected_main .selected_item:not(.coladded)').first().addClass('coladded');
        }
      }
    }, 200);
  }


    $('body').on('click', 'color-switcher.color-selection__image .remove_item', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();
        var $parent = $(this).parents('.color-selection__grid-item');        
        $parent.removeClass('coladded');

        var count = parseInt($parent.attr('data-count'));
        var totalCount = parseInt($parent.attr('data-total-count'));
        var $img = $parent.children('.color-selection__image');
        $parent.children('.color-selection__image').removeAttr('data-price');
        $parent.children('.color-selection__image').removeAttr('data-compare');
        $parent.children('.farbe-price_wrapper').find('.farbe-price').html('');
        $parent.children('.farbe-price_wrapper').find('.farbe-compare').html('');
        if ($parent.hasClass('optional-switcher')) {
            var countTotal = parseInt($parent.attr('data-total-count'));
            $parent.children('.farbe-title').text(`${window.translationsText.optionale}`);
            var visibleCount = $('.color-selection__grid-item.optional-switcher').length;

            if (visibleCount > 1) {
                $parent.remove();

                  let indexerOptional = parseInt($('#pick-color-id').attr('data-free-colors'));
                  $('.color-selection__grid-item.optional-switcher').each(function (index) {
                    indexerOptional += 1;
                    $(this).attr('data-count', indexerOptional);
                  })
              
                  var countTotal = parseInt($('#pick-color-id').attr('data-total-colors'));
                  var dataPercent = parseInt($('#pick-color-id').attr('data-optional-off'));
                  var countTotalOptional = parseInt($('#pick-color-id').attr('data-optional-colors'));
                  let countOptional = $('.color-selection__grid-item.optional-switcher.coladded').length;
                
                  let countOptionalUnselected = $('.color-selection__grid-item.optional-switcher:not(.coladded)').length;
                
                  if ((countOptional < countTotalOptional) && countOptionalUnselected == 0 && countTotalOptional > 0) {
                      let newItemHtml = `<div class="color-selection__grid-item optional-switcher" data-percent="${dataPercent}" data-count="${indexerOptional+1}" data-optional-count="${countTotalOptional}" data-total-count="${countTotal}">
                         <span class="discounted_percent">-${dataPercent}%</span>
                         <color-switcher class="color-selection__image optional-switcher color-selection__image--top pi-${indexerOptional+1}" data-ly-locked="true" is="toggle-button" aria-controls="color-choose-drawer" aria-expanded="false">
                            <button class="remove_item">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M13 1L1 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1 1L13 13" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                         </color-switcher>
                         <div class="farbe-title">${window.translationsText.optionale}</div>
                         <div class="farbe-vendor"></div>
                         <div class="farbe-price_wrapper">
                            <div class="farbe-price"></div>
                            <div class="farbe-compare"></div>
                         </div>
                      </div>`;
                    
                    $('.color-selection__container .color-selection__grid').append(newItemHtml)
      
                  }
            } else {
                $(`.color-selection__grid-item.optional-switcher[data-count="${count}"]`).children('.color-selection__image').addClass('readytoselect');
            }
          
        } else {
            $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-title').text(`${window.translationsText.design} ${count}`);
        }
        $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-vendor').text('');

        $parent.children('.color-selection__image').removeAttr('variant-name');
        $parent.children('.color-selection__image').removeAttr('variant-id');
        $parent.children('.color-selection__image').removeAttr('variant-img');
        $img.removeAttr('style');
        $img.removeClass('coladded');
        $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded:not(.disabled-color)').length);

        $('.color-selection__grid-item .color-selection__image.readytoselect').removeClass('readytoselect');
        $('.color-selection__grid-item.readytoselect').removeClass('readytoselect');
        $('.color-selection__grid-item .color-selection__image').attr("aria-expanded", "false");
        $('.color-selection__grid-item:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('active');
        $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().attr("aria-expanded", "true");
        updateCounter();

        if ($('color-switcher.color-selection__image.coladded').length > 0) {
          let colorNam = $('color-switcher.color-selection__image.coladded').last().attr('variant-name');
          $('.rosegold_heading p').html(`${colorNam} successfully selected`);
        } else {
          $('.rosegold_inner').hide();
          $('.press_nail_inner').hide();
          // $('.design_combinations_inner').show();
        }

         if ($("color-choose-drawer#color-choose-drawer").hasClass("color_ab_test")) {
            updateColorDrawerSlider();
            // if ($(`color-switcher.color-selection__image.coladded[variant-id=${variantId}]`).length > 0) {
            //  $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).last().removeAttr('variant-id');
            // } else {
            //    $(`.product-tile-item.active[data-variant=${variantId}]`).removeClass('active');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeClass('coladded');
            //   $(`.color_selected_main .selected_item[variant-id=${variantId}]`).removeAttr('variant-id');
            // }
          
          }


          
        const selectedColorLength = $('color-switcher.color-selection__image.coladded').length;
        let freeColorCount = [];
        $('variant-metacolor input').each(function () {
          const val = parseInt($(this).attr('data-free-colors'), 10);
          if (!isNaN(val)) {
            freeColorCount.push(val);
          }
        });
        if (freeColorCount.length > 0) {
          freeColorCount.sort(function(a, b) {
            return a - b;
          });
        }

        for (let index = 0; index < freeColorCount.length; index++) {
          // console.log('freeColorCount', freeColorCount[index]);
          if (selectedColorLength < freeColorCount[index]) {
            const optColor = parseInt($(`variant-metacolor input[data-free-colors="${freeColorCount[index-1]}"]`).attr('data-optional-colors'), 10);
            const totalColors = freeColorCount[index-1] + optColor;
            const varTitle = $(`.block-swatch-list .block-swatch input[data-total-colors="${totalColors}"]`);
              // console.log('varTitle', varTitle);
              if (varTitle.length) {
                $('color-switcher.color-selection__image.coladded').each(function (index) {
                    window.selectedVariantsArray.push($(this).attr('variant-id'));
                });
                varTitle.siblings('label.block-swatch__item').click();
                break; 
              }
          }
        }
        
      
    });

    $('body').on('click', '.product-tile-item .quantity_minus', function (evt) {
      let varID = $(this).closest('.product-tile-item').attr('data-variant');
      $(`color-switcher.color-selection__image.coladded[variant-id="${varID}"]`).last().find('.remove_item').click();
    });

function updateColorDrawerSlider() {
    if ($('.color_selected_main .selected_item').length > 0) {
      $('.color_selected_main .selected_item').each(function () {
        const index = $(this).attr('data-index');
        if ($(`.color-selection__grid-item.coladded[data-count="${index}"]:not(.disabled-color)`) && $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id')) {
          let imgURL = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-img');
          let varID = $(`.color-selection__grid-item.coladded[data-count="${index}"] color-switcher.color-selection__image.coladded`).attr('variant-id');
          $(this).css('backgroundImage', `url(${imgURL})`);
          $(this).addClass('coladded');
          $(this).attr('variant-id', varID);
        } else {
          $(this).css('backgroundImage', `url(https://www.doonails.com/cdn/shop/files/new-nail-bg.png?v=1696294386)`);
          $(this).removeClass('coladded');
          $(this).removeAttr('variant-id');
        }
      })
    }
    if ($('color-switcher.color-selection__image.coladded').length > 0) {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
      $('#color-choose-drawer .product-tile-item').find('input.quantity-selector__input').val(1);
      $('color-switcher.color-selection__image.coladded').each(function () {
        const varId = $(this).attr('variant-id');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).addClass('active');
        $(`#color-choose-drawer .product-tile-item[data-variant="${varId}"]`).find('input.quantity-selector__input').val($(`color-switcher.color-selection__image.coladded[variant-id="${varId}"]`).length);
      })
    } else {
      $('#color-choose-drawer .product-tile-item').removeClass('active');
    }
    if ($('.color_selected_main .selected_item.coladded').length > 0) {
      $('.color_choose_guarantee_inner').addClass('active');
    } else {
      $('.color_choose_guarantee_inner').removeClass('active')
    }
    
    let freeColorCount = [];
    $('variant-metacolor input').each(function () {
      const val = parseInt($(this).attr('data-free-colors'), 10);
      if (!isNaN(val)) {
        freeColorCount.push(val);
      }
    });
    if (freeColorCount.length > 0) {
      freeColorCount.sort(function(a, b) {
        return a - b;
      });
    }
    
    if ($(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase()) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[2]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else if ($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase()) {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[1]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    } else {
      if ($('color-switcher.color-selection__image.required-switcher.coladded').length >= freeColorCount[0]) {
        $('.color_selected_inner .selection_button').show();
      } else {
        $('.color_selected_inner .selection_button').hide();
      }
    }
      
  if (!$('body').hasClass('all_in_one_special_set')) {

  // if ($(`variant-metacolor input[data-free-colors="${freeColorCount[0]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase()) {
  //   if ($('.color_selected_main .selected_item.coladded').length == freeColorCount[0]) {
  //     const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-required-off');
  //     $('.product-item__label-list .label').hide();
  //     $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
  //     $('.product-item__label-list .percentOff').show();
  //   }
  //   if ($('.color_selected_main .selected_item.coladded').length >= freeColorCount[1]) {
  //     const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
  //     $('.product-item__label-list .label').hide();
  //     $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
  //     $('.product-item__label-list .percentOff').show();
  //   }
  // } else if ($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase()) {
  //   const totalOp = freeColorCount[1] + parseInt($(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-optional-colors'));
  //   if ($('.color_selected_main .selected_item.coladded').length >= freeColorCount[1] && $('.color_selected_main .selected_item.coladded').length != totalOp) {
  //     const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[1]}"]`).attr('data-required-off');
  //     $('.product-item__label-list .label').hide();
  //     $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
  //     $('.product-item__label-list .percentOff').show();
  //   } else if ($('.color_selected_main .selected_item.coladded').length == totalOp) {
  //     const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
  //     $('.product-item__label-list .label').hide();
  //     $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
  //     $('.product-item__label-list .percentOff').show();
  //   }
  // } else if ($(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-title').toLowerCase() == $('.block-swatch .block-swatch__radio:checked').attr('data-value').toLowerCase()) {
  //     const percentOff = $(`variant-metacolor input[data-free-colors="${freeColorCount[2]}"]`).attr('data-required-off');
  //     $('.product-item__label-list .label').hide();
  //     $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
  //     $('.product-item__label-list .percentOff').show();
  // }
  
    

    let selectedNo = parseInt($('.set-no-color_selected').first().text());
    let selectedTotal = parseInt($('.set-no-color').first().text());
    if (selectedNo == selectedTotal) {
      let selectedVar = $('form.shopify-product-form input[name="id"]').val();
      const percentOff = $(`variant-metacolor input[value="${selectedVar}"]`).attr('data-optional-off');
      $('.product-item__label-list .label').hide();
      // $('.product-item__label-list .percentOff').html(`-${percentOff}%`);
      // $('.product-item__label-list .percentOff').show();      
    } else {
      // $('.product-item__label-list .percentOff').html('');
      // $('.product-item__label-list .percentOff').hide();
      $('.product-item__label-list .label:not(.percentOff)').show();
    }

  }
}

$('.color_selected_inner .selection_button').on('click', function () {
  let freeColorCount = [];
  $('variant-metacolor input').each(function() {
    const val = parseInt($(this).attr('data-free-colors'), 10);
    if (!isNaN(val)) {
      freeColorCount.push(val);
    }
  });
  if (freeColorCount.length > 0) {
    freeColorCount.sort(function(a, b) {
      return a - b;
    });
  }

  for (let index = 0; index < freeColorCount.length; index++) {
    if (freeColorCount[index] == $('.color_selected_main .selected_item.coladded').length) {
      const varTitle = $(`variant-metacolor input[data-free-colors="${freeColorCount[index]}"]`).attr('data-title');
      $(`.block-swatch-list .block-swatch input[data-value="${varTitle}"]`).siblings('label.block-swatch__item').click();
    }
  }
  
  $('.popup-close.close-icon-popup').click();
})


  

if ($(window).width() < 860) {
    var stickyAtcDiv = $("product-payment-container#MainPaymentContainer");
    var productForm = $(".image-with-text-discount-btn_wrapper");

    if (productForm.get(0)) {
    function toggleStickyAtcDiv() {
        const rect = productForm.get(0).getBoundingClientRect();

        // Check if productForm is visible in the viewport (any part visible)
        const isVisible = rect.bottom > 0 && rect.top < $(window).height();

        if (isVisible) {
            stickyAtcDiv.removeClass('fixed');
        } else {
            stickyAtcDiv.addClass('fixed');
        }
    }

    $(window).on("scroll resize", toggleStickyAtcDiv);
    toggleStickyAtcDiv();
  }
}


    $('body').on('click', '#MainPaymentContainer', function(evt) {
        if ($(this).find('#AddToCart').attr('disabled') == 'disabled') {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('html, body').animate({
                scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
            }, 10);
            setTimeout(() => {
                $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
            }, 100);
        }
    });


    $('body').on('click', '.custom-new-upsell', function(evt) {
        if ($(this).find('.remover_upsell').attr('disabled') == 'disabled') {

            evt.preventDefault();
            evt.stopImmediatePropagation();
            $('color-switcher.color-selection__image.required-switcher.readytoselect').trigger('click');
        }
    });




    $('.color_choose_arrow').click(function() {
        let scroll = 100;
        if ($(this).hasClass('prev-arrow')) scroll *= -1;
        $('.color-filter-link-bar .link-bar__scroller').animate({
            scrollLeft: ($('.color-filter-link-bar .link-bar__scroller').scrollLeft() + scroll)
        }, 500);

    })


    $('.bullets-question_mark.Nagelkleber').click(function(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if ($(this).siblings('.Nagelkleber_content').is(":visible")) {
            $(this).text('?');
            $(this).siblings('.Nagelkleber_content').fadeOut();
        } else {
            $(this).text('x');
            $(this).siblings('.Nagelkleber_content').fadeIn();
        }

    })

    // $('whats-in-set#whats-in-set .product-tile-item').hover(

    //     function() { // Mouse enter function
    //         console.log('enter')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('x');
    //         $(this).find('.Nagelkleber_content').fadeIn();
    //     },
    //     function() { // Mouse leave function
    //         console.log('exit')
    //         $(this).find('.bullets-question_mark.Nagelkleber').text('?');
    //         $(this).find('.Nagelkleber_content').fadeOut();
    //     }
    // );

    // $("body").on('click', function(event) {
    //     if (!$(event.target).closest('color-choose-drawer#color-choose-drawer').length) {
    //         $('.color-selection__image').each(function(){
    //           $(this).closest('.color-selection__grid-item').removeClass('active');
    //           $(this).attr("aria-expanded", "false");
    //         })
    //         $('color-choose-drawer#color-choose-drawer').removeAttr('open');
    //         $('html').removeClass('lock-all');

    //     } 
    //   if (!$(event.target).closest('whats-in-set#whats-in-set').length){
    //     $('.whats-in-set[aria-controls="whats-in-set"]').attr("aria-expanded", "false"); 
    //       $('whats-in-set#whats-in-set').removeAttr('open');
    //     $('html').removeClass('lock-all');
    //   }
    // });


    $("color-choose-drawer#color-choose-drawer .popup-close").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
        if (!$('button#AddToCart').is('[disabled]')) {
          $('html, body').animate({
              scrollTop: $(".refill_purchase-wrapper").offset().top - 150
          }, 400);
        }
    });

    $("color-choose-drawer#color-choose-drawer .drawer__overlay").on('click', function(event) {
        $('.color-selection__image').each(function() {
            $(this).closest('.color-selection__grid-item').removeClass('active');
            $(this).attr("aria-expanded", "false");
        })
        $('color-choose-drawer#color-choose-drawer').removeAttr('open');
        $('html').removeClass('lock-all');
        if (!$('button#AddToCart').is('[disabled]')) {
          $('html, body').animate({
              scrollTop: $(".refill_purchase-wrapper").offset().top - 150
          }, 400);
        }
    });


    $("body").on(
        "click",
        ".products_filters_sortby .popout__toggle",
        function() {
            let $this = $(this);
            $(".products_filters_sortby .popout-list").slideToggle(function() {
                if ($(this).is(":visible")) {
                    $this.find(".down_close").css("transform", "rotate(180deg)");
                } else {
                    $this.find(".down_close").css("transform", "rotate(0deg)");
                }
            });
        }
    );

    $("body").on("click", "[data-sort-link]", function(evt) {
        evt.preventDefault();
        let valueSort = $(this).attr("data-value");
        let collectionHandle = $(this)
            .closest(".popout-list")
            .attr("data-collection");
        $(this).closest(".popout-list__item").addClass('active');
      $(this).closest(".popout-list__item").siblings().removeClass('active');
        $.ajax({
            url: `/collections/${collectionHandle}?view=set-bundle-sort&sort_by=${valueSort}`,
            type: "GET",
            success: function(response) {
                $('color-choose-drawer#color-choose-drawer').find(".products-tiles").html(response);
            },
            error: function(xhr, status, error) {
                // Handle any errors
                console.error("Error:", error);
            },
        });
    });

  

    // $(".option-popup .popup-inner .tags").slideDown();
    $("a.filters-pop").click(function(e) {
        e.preventDefault();

        $(".option-popup .popup-inner .tags").slideToggle();
        $(".sort-section").slideToggle();
        $(".search-area").slideUp();
    });

    $("a.search-pop").click(function(e) {
        e.preventDefault();
        $(".option-popup .popup-inner .tags").slideUp();
       $(".sort-section").slideUp();
        $(".search-area").slideToggle();
    });
  

  
    $(".tags-option1 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag1 = $(this).attr("data-value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag1 = null;
        } else {
            $(".tags-option1 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
            if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
              Shopify.analytics.publish('doonails:drawer_shape_clicked', {
                shape_value: selectedTag1,
                product_handle: window.location.pathname.split('/products/')[1] || null
              });
            }
            if (gtag) {
              gtag('event', 'drawer_shape_clicked', {
                'shape_value': selectedTag1,
                'product_handle': window.location.pathname.split('/products/')[1] || null
              });
            }
        }
        filterProductTiles(selectedTag1, getSelectedTag(".tags-option2"));
        updateDisabledStateNew(selectedTag1, "tags-option1");
        
      }
    });

    $(".tags-option2 .tag-wrapper").click(function() {
      if (!$(this).hasClass('disabled')) {
        var selectedTag2 = $(this).attr("data-value");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            selectedTag2 = null;
        } else {
            $(".tags-option2 .tag-wrapper").removeClass("active");
            $(this).addClass("active");
        }
        filterProductTiles(getSelectedTag(".tags-option1"), selectedTag2);
         updateDisabledStateNew(selectedTag2, "tags-option2");
      }
    });

    function getSelectedTag(selector) {
        return $(selector + " .tag-wrapper.active").attr("data-value");
    }

    function filterProductTiles(tag1, tag2) {
        $("color-choose-drawer#color-choose-drawer .product-tile-item").each(function() {
            var classes = $(this).attr("class").split(" ");
            var formClass, langeClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i];
                } else if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i];
                }
            }

            var showTile =
                (!tag1 || (formClass && formClass.split("_")[1] === tag1)) &&
                (!tag2 || (langeClass && langeClass.split("_")[1] === tag2));
            $(this).toggle(showTile);
        });
      
    }

    // function updateDisabledStateOld(tag1, tag2, option) {
    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     if (tag1 || tag2) {
    //         $(option + " .tag-wrapper").each(function() {
    //             var selectedTag = $(this).data("value");
    //             if (option === ".tags-option1") {
    //                 if (!tag2 && tag1 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             } else {
    //                 if (!tag1 && tag2 !== selectedTag) {
    //                     $(this).addClass("disabled");
    //                 }
    //             }
    //         });
    //     }
    // }

    // function updateDisabledState(tag1, tag2, option) {
    //     var tilesWithTagsB = [];

    //     var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
    //     visibleTiles.each(function() {
    //         var classes = $(this).attr("class").split(" ");
    //         var langeClass;
    //         for (var i = 0; i < classes.length; i++) {
    //             if (classes[i].startsWith("plange_")) {
    //                 langeClass = classes[i].split("_")[1];
    //                 tilesWithTagsB.push(langeClass);
    //                 break;
    //             }
    //         }
    //     });

    //     $(option + " .tag-wrapper").removeClass("disabled");
    //     $(option + " .tag-wrapper").each(function() {
    //         var selectedTag = $(this).data("value");
    //         if (!tilesWithTagsB.includes(selectedTag)) {
    //             $(this).addClass("disabled");
    //         }
    //     });
    // }

    function updateDisabledStateNew(tag, option) {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item:visible");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });

      $(".tags-option1 .tag-wrapper").removeClass("disabled");
      $(".tags-option2 .tag-wrapper").removeClass("disabled");
      
if (tag != null && option == 'tags-option1') {
  if ($(".tags-option2 .tag-wrapper.active").length == 0) {
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!tilesWithTagsB.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });
    
  } else {
    let dataVal = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var langClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langClass = classes[i].split("_")[1];
                    plangeArray.push(langClass);
                }
            }
        });
    // console.log('plangeArray', plangeArray)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!plangeArray.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(getSelectedTag(".tags-option1"), null);
            }
        });


    let dataVal2 = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray2 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal2}`).each(function() {
      var classes2 = $(this).attr("class").split(" ");
            var formClass2;
            for (var i = 0; i < classes2.length; i++) {
                if (classes2[i].startsWith("pform_")) {
                    formClass2 = classes2[i].split("_")[1];
                    pformArray2.push(formClass2);
                }
            }
        });
        // console.log('pformArray2', pformArray2)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!pformArray2.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });


  }
}

  
if (tag != null && option == 'tags-option2') {      
  if ($(".tags-option1 .tag-wrapper.active").length == 0) {
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!tilesWithTagsA.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });
  } else {

        let dataVal = $(".tags-option2 .tag-wrapper.active").attr('data-value');
    let pformArray = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.plange_${dataVal}`).each(function() {
      var classes = $(this).attr("class").split(" ");
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    pformArray.push(formClass);
                }
            }
        });
        // console.log('pformArray', pformArray)
            $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!pformArray.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
                // filterProductTiles(null, getSelectedTag(".tags-option2"));
            }
        });

        let dataVal1 = $(".tags-option1 .tag-wrapper.active").attr('data-value');
    let plangeArray1 = [];
    $(`color-choose-drawer#color-choose-drawer .product-tile-item.pform_${dataVal1}`).each(function() {
      var classes1 = $(this).attr("class").split(" ");
            var langClass1;
            for (var i = 0; i < classes1.length; i++) {
                if (classes1[i].startsWith("plange_")) {
                    langClass1 = classes1[i].split("_")[1];
                    plangeArray1.push(langClass1);
                }
            }
        });
    // console.log('plangeArray1', plangeArray1)
            $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!plangeArray1.includes(selectedTag)) {
                $(this).removeClass("active");
                $(this).addClass("disabled");
            }
        });

    
    }
  }



  updateDisabledStateStart();
}


  updateDisabledStateStart();
  
    function updateDisabledStateStart() {
        var tilesWithTagsA = [];
        var tilesWithTagsB = [];

        var visibleTiles = $("color-choose-drawer#color-choose-drawer .product-tile-item");
        visibleTiles.each(function() {
            var classes = $(this).attr("class").split(" ");
            var langeClass;
            var formClass;
            for (var i = 0; i < classes.length; i++) {
                if (classes[i].startsWith("plange_")) {
                    langeClass = classes[i].split("_")[1];
                    tilesWithTagsB.push(langeClass);
                }
                if (classes[i].startsWith("pform_")) {
                    formClass = classes[i].split("_")[1];
                    tilesWithTagsA.push(formClass);
                }
            }
        });
      
      
        $(".tags-option1 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!tilesWithTagsA.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });

     
        $(".tags-option2 .tag-wrapper").each(function() {
            var selectedTag = $(this).attr("data-value");
            if (!tilesWithTagsB.includes(selectedTag)) {
                $(this).addClass("disabled");
            }
        });

}
  

    $(".product-search").on("input", function() {
        var searchQuery = $(this).val().trim().toLowerCase();

        filterProductBySearch(searchQuery);
        toggleClearButton(searchQuery);
    });

    $(".clear-search-btn").on("click", function() {
        $(".product-search").val("").trigger("input").focus();
        $(this).hide();
    });

    $(".search_again").on("click", function() {
        $(".product-search").val("").trigger("input").focus();
    });

    function filterProductBySearch(searchQuery) {
      let allHide = true;
      $("color-choose-drawer .product-tile-item").each(function() {
          var productName = $(this).data("name");
          var keywords = $(this).data("keywords");
          if (productName) {
              productName = productName.toLowerCase();
              if (keywords) {
                keywords = keywords.toLowerCase();
              }
              var showTile = !searchQuery || productName.includes(searchQuery) || keywords.includes(searchQuery);
              var attributeValue = $(this).attr("hidden");
              if (typeof attributeValue == "undefined" || attributeValue == false) {
                $(this).toggle(showTile);
              }              
          }
          if ($(this).is(':visible')) {
            allHide = false;
          }
      });
      if (allHide) {
        $('.products-tiles-empty').show();
      } else {
        $('.products-tiles-empty').hide();
      }
    }

    function toggleClearButton(searchQuery) {
        $(".clear-search-btn").toggle(searchQuery.length > 0);
    }


    $('#AddToCart').attr('disabled', 'true');
    $('#StickyAddToCart').addClass('disabled');
    $('#AddToCart .loader-button__text').text(window.translationsText.buttonUnfilled + ' 1');


});

/*po set coding */
if ($('.custom-po-set').length > 0) {
    $(window).on('load', function() {
        // PoSetRefresh($('input[name="option1"]:checked').val());
        const firstOptionSelector = document.querySelector('.custom-po-set .block-swatch__radio:checked');
        PoSetRefresh(firstOptionSelector.getAttribute('data-value'));
    });
    document.addEventListener('variant:changed', function(event) {
        let variant = event.detail.variant;
        $('#AddToCart[data-product-add-to-cart-button]').attr('data-price', variant.price);
        PoSetRefresh(variant.title);
    });
}

function PoSetRefresh(variant_title) {

  const firstOptionSelector = $('.custom-po-set .block-swatch__radio:checked');
  let selectedIndex = firstOptionSelector.attr('data-index');
  let selectedValue = firstOptionSelector.attr('data-value');
    $('.free_top_svg').attr('data-index', selectedIndex);
  
      // if (selectedValue == '2 Designs' || selectedValue == '3 Designs' || selectedValue == '2 Colors') {
      //   $('.free_product_col').each(function (index) {
      //         $(this).addClass('notAdded');
      //         $(this).removeClass('coladded');
      //   });
      // } else if (selectedValue == '4 Designs' || selectedValue == '6 Designs') {
      //    $('.free_product_col').each(function (index) {
      //         $(this).removeClass('notAdded');
      //         $(this).addClass('coladded');
      //   });
      // }
      // else if (selectedValue == '2+1 Gratis Designs') {
      //   $('.free_product_col').each(function (index) {
      //       if ($(this).attr('data-handle') == "nagel-cuticle-ol") {
      //         $(this).addClass('notAdded');
      //         $(this).removeClass('coladded');
      //       } else {
      //         $(this).removeClass('notAdded');
      //         $(this).addClass('coladded');
      //       }
      //   });
      // } else if (selectedValue == '5 Designs') {
      //   $('.free_product_col').each(function (index) {
      //     if ($(this).attr('data-handle') == "2-in-1-buffer-feile") {
      //         $(this).removeClass('notAdded');
      //         $(this).addClass('coladded');
      //       } else {
      //         $(this).addClass('notAdded');
      //         $(this).removeClass('coladded');
      //       }
      //   });
      // }
      // else {
      //    $('.free_product_col').each(function (index) {
      //         $(this).removeClass('notAdded');
      //         $(this).addClass('coladded');
      //   });
      // }
  
 let variant_title_down = selectedValue.toLowerCase();
 variant_title_down = variant_title_down.trim();
 variant_title_down = variant_title_down.replace(/[\s+]/g, "_");
 let variant_id = $('.product-form__buy-buttons input[name="id"]').val();

 let allow_colors = parseInt($(`variant-metacolor input[value="${variant_id}"]`).attr('data-free-colors'));
 let optional_colors = parseInt($(`variant-metacolor input[value="${variant_id}"]`).attr('data-optional-colors'));


  
 $('.set-no-color').text(allow_colors);

  $('.set-no-color_selected').html($('.color-selection__grid-item.required-switcher.coladded:not(.disabled-color)').length); 
  
        $(`.hide_on_other_variant`).hide();
        setTimeout(() => {
          $(document.getElementsByClassName('show_' + variant_title_down)).show();
          $(`.show_all_variant`).show();
        }, 50);
      
        var countTotalOptional = optional_colors;
        var currentCount = allow_colors + 1;
        // var percentOff = $('#pick-color-id').attr('data-optional-off');
  
  
    updateCounter()
}


$("body").on("change", '.optional_accessories_block_product_item', function(evt) {
   updateCounter();
});

function updateCounter() {

    setTimeout(() => {
        /* set_refil_new_pr_on_sub: Leiste, Badges, Kaufknopf und atcPrice rechnet snippets/dn-refill-atc.liquid aus der
           Stufen-Tabelle (bundle-discount / Loop "(N Designs)", Bilal 2026-10-09). Die feste Leiter unten (15/21/30/38,
           2195 je Design) schrieb 200 ms nach jedem Kaufart-Wechsel alte Werte darueber. */
        if (window.dnRefillAtcBereit) {
          if (typeof window.dnRechne === 'function') window.dnRechne();
          return;
        }
        let selectedNo = parseInt($('.set-no-color_selected').first().text());
        let selectedTotal = parseInt($('.set-no-color').first().text());

        
        let selectedLength = $('.color-selection__grid color-switcher.color-selection__image.coladded').length;

        if (selectedLength == 3) {
           $('#progressFill').css('width', '0%');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-21%`);
            $('.refill_card-top-badge').html('GET 15% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-10%`);
           }
           $('.product-item__label-list .percentOff').show();  
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').removeClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').removeClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').removeClass('active');  
          $('.product-title__variant').html('(3 Designs)');        

        } else if (selectedLength == 4) {
           $('#progressFill').css('width', '30%');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-21%`);
            $('.refill_card-top-badge').html('GET 21% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-10%`);
           }
           $('.product-item__label-list .percentOff').show();  
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').removeClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').removeClass('active');
          $('.product-title__variant').html('(4 Designs)');  
        } else if (selectedLength == 5) {
            $('#progressFill').css('width', '50%');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-30%`);
            $('.refill_card-top-badge').html('GET 21% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-20%`);
           }
           $('.product-item__label-list .percentOff').show();  
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').removeClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').removeClass('active');
          $('.product-title__variant').html('(5 Designs)');  
        } else if (selectedLength == 6) {
            $('#progressFill').css('width', '70%');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-30%`);
            $('.refill_card-top-badge').html('GET 30% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-20%`);
           }
           $('.product-item__label-list .percentOff').show();  
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').removeClass('active');
          $('.product-title__variant').html('(6 Designs)');  
        } else if (selectedLength == 7) {
            $('#progressFill').css('width', '86%');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-38%`);
            $('.refill_card-top-badge').html('GET 30% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-25%`);
           }
           $('.product-item__label-list .percentOff').show();  
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').removeClass('active');
          $('.product-title__variant').html('(7 Designs)');  
        } else if (selectedLength >= 8) {
            $('#progressFill').css('width', '100%');
           $('.refill-discount__option-wrap[data-index="1"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="2"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="3"]').addClass('active');
           $('.refill-discount__option-wrap[data-index="4"]').addClass('active');
           if ($(".refill_purchase-option:checked").val() == "subscription") {
            $('.product-item__label-list .percentOff').html(`-38%`);
            $('.refill_card-top-badge').html('GET 38% OFF');
           } else {
            $('.product-item__label-list .percentOff').html(`-25%`);
           }
           $('.product-item__label-list .percentOff').show(); 
          $('.product-title__variant').html('(8 Designs)');  
        } else {
          $('#progressFill').css('width', '0%');
          $('.refill_card-top-badge').html('GET 15% OFF');
          $('.refill-discount__option-wrap').removeClass('active');
          $('.product-item__label-list .percentOff').html("");
          $('.product-item__label-list .percentOff').hide();
          $('.product-title__variant').html('(3 Designs)');  
        }

        if (selectedLength > 2) {
          const oneDesignDiscountedPrice = parseInt($(".refill_purchase-option:checked + .refill_purchase-card").find(".refill_new-price").attr("data-price")) * selectedLength;
          const oneDesignOriginalPrice = 2195 * selectedLength;
          $('#AddToCart[data-product-add-to-cart-button] .loader-button__text').html(`Buy now | <span class="atc_copmare_btn">${window.globalMoneyFm(oneDesignOriginalPrice)}</span> <span class="atc_price_btn">${window.globalMoneyFm(oneDesignDiscountedPrice)}</span>`);
          $('#AddToCart[data-product-add-to-cart-button]').removeAttr('disabled');
          window.atcPrice = oneDesignDiscountedPrice;
          window.atcPriceCompare = oneDesignOriginalPrice;
      
          const oneDesignDiscountedPriceSub = parseInt($(".refill_purchase-card.refill_subscribe-card").find(".refill_new-price").attr("data-price")) * selectedLength;
          $('.refill_purchase-wrapper .refill_total-price').html(window.globalMoneyFm(oneDesignDiscountedPriceSub));
          
        } else {
          $('#AddToCart .loader-button__text').text(`${window.translationsText.buttonUnfilled} ${selectedNo + 1}`);
          $('.color-selection__grid-item.readytoselect').removeClass('readytoselect');
          $('.color-selection__grid-item:not(.coladded)').first().addClass('readytoselect');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image.readytoselect').removeClass('readytoselect');
          $('.color-selection__grid-item:not(.disabled-color) .color-selection__image:not(.coladded)').first().addClass('readytoselect');
          $('#AddToCart[data-product-add-to-cart-button]').attr('disabled', 'true');

          const oneDesignDiscountedPriceSub = parseInt($('.refill_purchase-wrapper .refill_total-price').attr('data-price'));
          $('.refill_purchase-wrapper .refill_total-price').html(window.globalMoneyFm(oneDesignDiscountedPriceSub));;
          
        }

      
    }, 200);
}


$(document).ready(function() {
    $(".shopify-section-custom_accordion .collapsible-toggle").click(function(event) {
        event.preventDefault();
        let clickedEle = $(this);
        let ariaExp = clickedEle.attr('aria-expanded')
        $(this).addClass('clicked')
        $(".shopify-section-custom_accordion .collapsible-toggle:not(.clicked)").each(function() {
            $(this).attr('aria-expanded', 'false');
            $(this).siblings('collapsible-content').removeAttr('open');
        })

        if (ariaExp != 'false') {
            $(this).removeClass('clicked')
        }

    });

    // $("body").on("change", 'input[name="refill_purchase_type"]', function(){
    //   if ($(this).val() == "onetime") {
    //     window.currentVariant = "onetime";
    //     $(".color-selection__grid-item.color_selection__refill").addClass("onetime_active");
    //     $(".color-selection__grid-item.color_selection__refill").removeClass("subscription_active");
    //   } else {
    //     window.currentVariant = "subscription";
    //     $(".color-selection__grid-item.color_selection__refill").removeClass("onetime_active");
    //     $(".color-selection__grid-item.color_selection__refill").addClass("subscription_active");
    //   }
    //   updateCounter();
    // })

    $("body").on("change", 'input[name="refill_purchase_type"]', function(){
      if ($(this).val() == "onetime") {
        $(".subscription_off_refill").hide();
        $(".onetime_off_refill").show();
      } else {
        $(".onetime_off_refill").hide();
        $(".subscription_off_refill").show();
      }
      updateCounter();
    })

    $("body").on("change", 'select.refill_subscription-select', function(){
      const selectedValue = $(this).val();
      const selectedOption = $(this).find(`option[value="${selectedValue}"]`);
      if (selectedOption && selectedOption.length) {
        const durationTime = selectedOption.attr('data-week');
        $('.set_refil_new_pr_on_sub_v2 .refill_purchase-option:checked + .refill_purchase-card .refill_delivery_duration').html(durationTime);
      }
    })

    // document.addEventListener('variant:changed', function(event) {
    //   window.currentVariant = $('input[name="refill_purchase_type"]:checked').val();
    // })

    document.addEventListener("doc:rerendered", (event) => {
      // console.log(window.currentVariant);
      if (window.currentVariant == "onetime") {
        $("label.refill_purchase-card.refill_one-time-card").click();
      } else if (window.currentVariant == "subscription") {
        $("label.refill_purchase-card.refill_subscribe-card").click();
      }
      updateCounter();
    })
  
});
